export enum NtpeObservationSection {
    GOALS = 1,
    ACTION_PLAN = 2,
    PRE_CONFERENCE = 3,
    MID_YEAR_UPDATE = 4,
    END_YEAR_UPDATE = 5,
    RUBRIC = 6,
    POST_CONFERENCE = 7,
    AUTHENTICATE = 8
}
